module.exports = __webpack_public_path__ + "static/media/star.55b594fe.png";